import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, Stack, TextField } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import Loader3D from "../../components/Loader/Loader3D";
import {
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../components/mui/Buttons/Buttons";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getApprovalstatuses,
  getCartEditRequests,
  postApprovalFinance,
  postApprovalStatus,
  updateApprovalstatus,
} from "../../redux/features/generalSlice";
import { useSnackbar } from "notistack";
import { savePaginationData } from "../../redux/features/globalDatagridSlice";

const FinanceApproval = ({ dispatchParams, requestId, row }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, approvalStatuses } = useSelector((store) => store.general);
  const { enqueueSnackbar } = useSnackbar();
  const { paginationData } = useSelector((state) => state.globalDataGrid);

  // const getTitle = (name) => {
  //   const match = titleAndFields?.titles?.find(
  //     (title) => title.fieldName === name
  //   );
  //   return match ? match.id : "";
  // };

  const initialValues = {
    approval_remarks: row?.approval_remarks,
    approval_status: row?.approval_status,
    requestId: requestId,
  };

  const schema = Yup.object({
    approval_status: Yup.number().required("Status Required"),
    approval_remarks: Yup.string().required("Description Required"),
    // fields: Yup.array().min(1, "At least one field is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(values);
      const data = {
        ...values,
      };
      if (row?.approval_status) {
        dispatch(updateApprovalstatus(data)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(getCartEditRequests(dispatchParams));
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      } else {
        dispatch(postApprovalFinance(data)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
            dispatch(getCartEditRequests(dispatchParams));
            setOpen(false);
          }
        });
      }
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getApprovalstatuses());
    }
  }, [open]);

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Approval Status"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
            sx={{
              marginLeft: "10px",
              p: "7px 10px",
              gap: "5px",
              background:
                "linear-gradient(108deg,rgb(37, 198, 152),rgba(48, 171, 46, 0.32))",
              color: "#fff",
              "&:hover": {
                background:
                  "linear-gradient(108deg,rgb(66, 213, 147),rgba(21, 183, 99, 0.32))",
              },
            }}
            variant="contained"
            disabled={false}
            onClick={() => setOpen(true)}
            size="small"
          >
            Approve
          </Button>
        </>
      }
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Stack gap={2}>
                      <Box>
                        <GlobalSelectField
                          options={{
                            formik: formik,
                            label: "Status",
                            name: "approval_status",
                            data: approvalStatuses,
                            keys: {
                              id: "approval_status_id",
                              value: "approval_status_name",
                            },
                            sx: {
                              width: "100%",
                            },
                          }}
                        />
                      </Box>

                      <Box>
                        <TextField
                          type="text"
                          autoComplete="off"
                          fullWidth
                          label="Remarks"
                          rows={3}
                          multiline
                          name="approval_remarks"
                          value={formik.values.approval_remarks}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.approval_remarks &&
                            Boolean(formik.errors.approval_remarks)
                          }
                          helperText={
                            formik.touched.approval_remarks &&
                            formik.errors.approval_remarks
                          }
                        />
                      </Box>
                    </Stack>
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                  >
                    <Stack direction={"row"} spacing={1}>
                      <CancelButton action={() => handleCancel()}>
                        Cancel
                      </CancelButton>
                      {false ? (
                        <UpdateButton disabled={loading} type="submit">
                          {loading ? "Updating..." : "Update Request"}
                        </UpdateButton>
                      ) : (
                        <SubmitButton disabled={loading} type="submit">
                          {loading ? "Submiting..." : "Submit"}
                        </SubmitButton>
                      )}
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default FinanceApproval;
